import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { MemberService } from '../../core/services/member.service';
import { CounselService } from '../../core/services/counsel.service';
import { FlashService } from '../../core/services/flash.service';
import { BusinessDateInputComponent, validOptionalBusinessDate } from '../../shared/components/business-date-input.component';

@Component({
    selector: 'app-counsel-new',
    imports: [MaxLengthValidatorDirective, RouterLink, FormsModule, DecimalPipe, BusinessDateInputComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i>&nbsp;新規作成</span>
    </div>
    <div class="card-body">
      <div style="height: 1px"></div>
      <div class="row">
        <div class="col-md-3 text-md-right">会員氏名：</div>
        <div class="col-md-9 form-group">{{ member?.lastName }}&nbsp;{{ member?.firstName }}</div>
        <div class="col-md-3 text-md-right">区分コース：</div>
        <div class="col-md-9 form-group">{{ member?.studioPlan?.name }}</div>
      </div>
      <hr />
    </div>
    <div class="card-body">
      <div class="col-md-12">
        <form novalidate name="counselEditForm" #counselEditForm="ngForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <div class="col-md-4">
                  <label class="col-form-label">担当者</label>
                  <input type="text" class="form-control" [(ngModel)]="counsel.counselor" name="counselor" sfMaxLength="255">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-4">
                  <label class="col-form-label">実施日</label>
                  <app-business-date-input name="counseled_at" [(ngModel)]="counsel.counseledAt"></app-business-date-input>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">100日後の目標</label>
                  <input type="text" class="form-control" [(ngModel)]="counsel.aimIn100Days" name="aimIn100Days" placeholder="フリーワード入力（255文字以内）" sfMaxLength="255">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-4">
                  <label class="col-form-label" for="training_program_id">実施メニュー</label>
                  <select class="form-control" id="training_program_id" name="training_program_id" [(ngModel)]="select.trainingProgram" required>
                    <option [ngValue]="null">-- 選択してください --</option>
                    @for (t of trainingPrograms; track t.id) {
                      <option [ngValue]="t">{{ t.name }}</option>
                    }
                  </select>
                </div>
              </div>

              <div class="form-group">
                <div class="col-md-4 row align-items-end">
                  <label class="col-form-label w-100">体重（kg）</label>
                  <select class="form-control col-8" [(ngModel)]="counsel.weightInteger" name="weightInteger" (ngModelChange)="updateCaloriesToTake()">
                    <option [ngValue]="null">--</option>
                    @for (n of range(20, 150); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                  <div><span>&nbsp;.&nbsp;</span></div>
                  <select class="form-control col-3" [(ngModel)]="counsel.weightDecimal" name="weightDecimal" (ngModelChange)="updateCaloriesToTake()">
                    <option [ngValue]="null">--</option>
                    @for (n of range(0, 9); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4 row align-items-end">
                  <label class="col-form-label w-100">体脂肪率（％）</label>
                  <select class="form-control col-8" [(ngModel)]="counsel.bodyFatPercentageInteger" name="bodyFatPercentageInteger" (ngModelChange)="updateCaloriesToTake()">
                    <option [ngValue]="null">--</option>
                    @for (n of range(3, 50); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                  <div><span>&nbsp;.&nbsp;</span></div>
                  <select class="form-control col-3" [(ngModel)]="counsel.bodyFatPercentageDecimal" name="bodyFatPercentageDecimal" (ngModelChange)="updateCaloriesToTake()">
                    <option [ngValue]="null">--</option>
                    @for (n of range(0, 9); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4 row align-items-end">
                  <label class="col-form-label w-100">筋肉量（kg）</label>
                  <select class="form-control col-8" [(ngModel)]="counsel.muscleMassInteger" name="muscleMassInteger">
                    <option [ngValue]="null">--</option>
                    @for (n of range(10, 90); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                  <div><span>&nbsp;.&nbsp;</span></div>
                  <select class="form-control col-3" [(ngModel)]="counsel.muscleMassDecimal" name="muscleMassDecimal">
                    <option [ngValue]="null">--</option>
                    @for (n of range(0, 9); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4 row align-items-end">
                  <label class="col-form-label w-100">太もも周り（cm）</label>
                  <select class="form-control col-8" [(ngModel)]="counsel.thighCircumferenceInteger" name="thighCircumferenceInteger">
                    <option [ngValue]="null">--</option>
                    @for (n of range(20, 100); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                  <div><span>&nbsp;.&nbsp;</span></div>
                  <select class="form-control col-3" [(ngModel)]="counsel.thighCircumferenceDecimal" name="thighCircumferenceDecimal">
                    <option [ngValue]="null">--</option>
                    @for (n of range(0, 9); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4 row align-items-end">
                  <label class="col-form-label w-100">お尻周り（cm）</label>
                  <select class="form-control col-8" [(ngModel)]="counsel.hipCircumferenceInteger" name="hipCircumferenceInteger">
                    <option [ngValue]="null">--</option>
                    @for (n of range(20, 150); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                  <div><span>&nbsp;.&nbsp;</span></div>
                  <select class="form-control col-3" [(ngModel)]="counsel.hipCircumferenceDecimal" name="hipCircumferenceDecimal">
                    <option [ngValue]="null">--</option>
                    @for (n of range(0, 9); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4 row align-items-end">
                  <label class="col-form-label w-100">お腹周り（cm）</label>
                  <select class="form-control col-8" [(ngModel)]="counsel.abdominalCircumferenceInteger" name="abdominalCircumferenceInteger">
                    <option [ngValue]="null">--</option>
                    @for (n of range(20, 150); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                  <div><span>&nbsp;.&nbsp;</span></div>
                  <select class="form-control col-3" [(ngModel)]="counsel.abdominalCircumferenceDecimal" name="abdominalCircumferenceDecimal">
                    <option [ngValue]="null">--</option>
                    @for (n of range(0, 9); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4 row align-items-end">
                  <label class="col-form-label w-100">二の腕周り（cm）</label>
                  <select class="form-control col-8" [(ngModel)]="counsel.armCircumferenceInteger" name="armCircumferenceInteger">
                    <option [ngValue]="null">--</option>
                    @for (n of range(10, 50); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                  <div><span>&nbsp;.&nbsp;</span></div>
                  <select class="form-control col-3" [(ngModel)]="counsel.armCircumferenceDecimal" name="armCircumferenceDecimal">
                    <option [ngValue]="null">--</option>
                    @for (n of range(0, 9); track n) { <option [ngValue]="n">{{ n }}</option> }
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">1日にとるべき理想の摂取カロリー（kcal）： {{ counsel.caloriesToTake | number:'1.1-1' }}</label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">
                    <span>トレーナーコメント </span>
                    <button type="button" class="btn btn-success text-white" (click)="openMachineInfoModal()"><i class="fa s-icon-plus"></i>&nbsp;マシン詳細追記</button>
                  </label>
                  <textarea type="text" class="form-control" rows="10" [(ngModel)]="counsel.note" name="note" placeholder="フリーワード入力（1024文字以内）" sfMaxLength="1024"></textarea>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">次回までの目標</label>
                  <textarea type="text" class="form-control" rows="5" [(ngModel)]="counsel.aimInNextTime" name="aimInNextTime" placeholder="フリーワード入力（512文字以内）" sfMaxLength="512"></textarea>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12 text-right">
            <a [routerLink]="['/counsel', memberId]" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
            <button type="button" (click)="save()" class="btn btn-success" [disabled]="saving || counselEditForm.invalid || !select.trainingProgram || !validDate(counsel.counseledAt)"><i class="fa s-icon-save"></i>&nbsp;保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showMachineInfoModal) {
  <div class="modal-backdrop fade show" (click)="showMachineInfoModal = false"></div>
  <div class="modal fade show d-block" id="machineInfoModal" tabindex="-1" role="dialog" aria-labelledby="machineInfoModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="machineInfoModalLabel">マシン詳細追記</h5>
          <button type="button" class="close" (click)="showMachineInfoModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form novalidate name="machineInfoModalForm">
        <div class="modal-body">
          <div class="form-group col-12 row">
            <label class="col-form-label">使用マシン</label>
            <select class="form-control" [(ngModel)]="machineInfo.machine" name="machineInfoMachine">
              <option [ngValue]="null">--</option>
              @for (machine of trainingMachines; track machine.id) {
                <option [ngValue]="machine">{{ machine.name }}</option>
              }
            </select>
          </div>
          @if (machineInfo.machine?.maxAdjustment1) {
            <div class="form-group col-12 row">
              <label class="col-form-label">調整箇所1</label>
              <select class="form-control" [(ngModel)]="machineInfo.adjustment1" name="machineAdjustment1">
                <option [ngValue]="null">--</option>
                @for (n of range(machineInfo.machine?.minAdjustment, machineInfo.machine?.maxAdjustment1); track n) { <option [ngValue]="n">{{ n }}</option> }
              </select>
            </div>
          }
          @if (machineInfo.machine?.maxAdjustment2) {
            <div class="form-group col-12 row">
              <label class="col-form-label">調整箇所2</label>
              <select class="form-control" [(ngModel)]="machineInfo.adjustment2" name="machineAdjustment2">
                <option [ngValue]="null">--</option>
                @for (n of range(machineInfo.machine?.minAdjustment, machineInfo.machine?.maxAdjustment2); track n) { <option [ngValue]="n">{{ n }}</option> }
              </select>
            </div>
          }
          @if (machineInfo.machine?.maxAdjustment3) {
            <div class="form-group col-12 row">
              <label class="col-form-label">調整箇所3</label>
              <select class="form-control" [(ngModel)]="machineInfo.adjustment3" name="machineAdjustment3">
                <option [ngValue]="null">--</option>
                @for (n of range(machineInfo.machine?.minAdjustment, machineInfo.machine?.maxAdjustment3); track n) { <option [ngValue]="n">{{ n }}</option> }
              </select>
            </div>
          }
          @if (machineInfo.machine?.maxAdjustment4) {
            <div class="form-group col-12 row">
              <label class="col-form-label">調整箇所4</label>
              <select class="form-control" [(ngModel)]="machineInfo.adjustment4" name="machineAdjustment4">
                <option [ngValue]="null">--</option>
                @for (n of range(machineInfo.machine?.minAdjustment, machineInfo.machine?.maxAdjustment4); track n) { <option [ngValue]="n">{{ n }}</option> }
              </select>
            </div>
          }
          @if (machineInfo.machine?.maxWeight) {
            <div class="form-group col-12 row align-items-end">
              <label class="col-form-label w-100">重量（kg）</label>
              <select class="form-control col-6" [(ngModel)]="machineInfo.weightInteger" name="machineWeightInteger">
                <option [ngValue]="null">--</option>
                @for (n of range(machineInfo.machine?.minWeight, machineInfo.machine?.maxWeight); track n) { <option [ngValue]="n">{{ n }}</option> }
              </select>
              <div><span>&nbsp;.&nbsp;</span></div>
              <select class="form-control col-3" [(ngModel)]="machineInfo.weightDecimal" name="machineWeightDecimal">
                <option [ngValue]="null">--</option>
                @for (n of range(0, 9); track n) { <option [ngValue]="n">{{ n }}</option> }
              </select>
            </div>
          }
          @if (machineInfo.machine?.setNumber) {
            <div class="form-group col-12 row">
              <label class="col-form-label">セット数</label>
              <select class="form-control" [(ngModel)]="machineInfo.setNumber" name="machineSetNumber">
                <option [ngValue]="null">--</option>
                @for (n of range(1, machineInfo.machine?.setNumber); track n) { <option [ngValue]="n">{{ n }}</option> }
              </select>
            </div>
          }
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showMachineInfoModal = false">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-success text-white" type="button" (click)="addMachineInfo()" [disabled]="!canAddMachineInfo()">
            <i class="fa s-icon-edit"></i>&nbsp;追記
          </button>
        </div>
        </form>
      </div>
    </div>
  </div>
}
  `
})
export class CounselNewComponent implements OnInit {
  @ViewChild('counselEditForm') counselEditForm?: NgForm;
  private pageTitleService = inject(PageTitleService);
  private memberService = inject(MemberService);
  private counselService = inject(CounselService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private flash = inject(FlashService);

  memberId!: number;
  member: any = null;
  personal: any = null;
  trainingPrograms: any[] = [];
  trainingMachines: any[] = [];
  counsel: any = Object.fromEntries([
    'weightInteger', 'weightDecimal', 'bodyFatPercentageInteger', 'bodyFatPercentageDecimal',
    'muscleMassInteger', 'muscleMassDecimal', 'thighCircumferenceInteger', 'thighCircumferenceDecimal',
    'hipCircumferenceInteger', 'hipCircumferenceDecimal', 'abdominalCircumferenceInteger',
    'abdominalCircumferenceDecimal', 'armCircumferenceInteger', 'armCircumferenceDecimal',
  ].map(key => [key, null]));
  select: any = { trainingProgram: null };
  machineInfo: any = { machine: null, adjustment1: null, adjustment2: null, adjustment3: null, adjustment4: null, weightInteger: null, weightDecimal: null, setNumber: null };
  showMachineInfoModal = false;
  saving = false;

  range(min: number | null | undefined, max: number | null | undefined): number[] {
    if (max === null || max === undefined) return [];
    const start = Number(min ?? 0);
    const end = Number(max);
    const arr = [];
    for (let i = start; i <= end; i++) arr.push(i);
    return arr;
  }

  updateCaloriesToTake(): void {
    // The decimal selector can retain a value after the integer is cleared.
    if (this.counsel.weightInteger == null || this.counsel.weightInteger === '' ||
        this.counsel.bodyFatPercentageInteger == null || this.counsel.bodyFatPercentageInteger === '') {
      this.counsel.caloriesToTake = null;
      return;
    }
    const weight = parseFloat(String(this.counsel.weightInteger ?? '') + '.' + String(this.counsel.weightDecimal ?? 0));
    const bfp = parseFloat(String(this.counsel.bodyFatPercentageInteger ?? '') + '.' + String(this.counsel.bodyFatPercentageDecimal ?? 0));
    const kcal = Math.round(((weight - weight * bfp / 100) * 35) * 10) / 10;
    this.counsel.caloriesToTake = isNaN(kcal) ? null : kcal;
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員管理', 's-icon-members');
    this.memberId = +this.route.snapshot.params['memberId'];
    [this.member, this.personal, this.trainingPrograms, this.trainingMachines] = await Promise.all([
      this.memberService.getOne(this.memberId),
      this.memberService.getPersonal(this.memberId),
      this.counselService.getTrainingProgramList(),
      this.counselService.getTrainingMachineList(),
    ]);
    this.member = this.member ?? null;
    this.trainingPrograms = this.trainingPrograms ?? [];
    this.trainingMachines = this.trainingMachines ?? [];
  }

  openMachineInfoModal(): void {
    this.machineInfo = { machine: null, adjustment1: null, adjustment2: null, adjustment3: null, adjustment4: null, weightInteger: null, weightDecimal: null, setNumber: null };
    this.showMachineInfoModal = true;
  }

  canAddMachineInfo(): boolean {
    const machine = this.machineInfo.machine;
    if (!machine) return false;
    if (machine.maxWeight && (this.machineInfo.weightInteger === null || this.machineInfo.weightInteger === undefined || this.machineInfo.weightDecimal === null || this.machineInfo.weightDecimal === undefined)) return false;
    if (machine.setNumber && !this.machineInfo.setNumber) return false;
    return true;
  }

  addMachineInfo(): void {
    if (!this.canAddMachineInfo()) return;
    const info = this.machineInfo;
    let str = this.counsel.note ? '\n' : '';
    str += `・${info.machine.name} `;
    str += info.adjustment1 !== null && info.adjustment1 !== undefined ? `調整箇所①${info.adjustment1} ` : '';
    str += info.adjustment2 !== null && info.adjustment2 !== undefined ? `調整箇所②${info.adjustment2} ` : '';
    str += info.adjustment3 !== null && info.adjustment3 !== undefined ? `調整箇所③${info.adjustment3} ` : '';
    str += info.adjustment4 !== null && info.adjustment4 !== undefined ? `調整箇所④${info.adjustment4} ` : '';
    str += info.weightInteger !== null && info.weightInteger !== undefined ? `重量${info.weightInteger}.${info.weightDecimal ?? 0}kg ` : '';
    str += info.setNumber ? `${info.setNumber}セット` : '';
    this.counsel.note = this.counsel.note ? this.counsel.note + str : str;
    this.machineInfo = { machine: null, adjustment1: null, adjustment2: null, adjustment3: null, adjustment4: null, weightInteger: null, weightDecimal: null, setNumber: null };
    this.showMachineInfoModal = false;
  }

  async save(): Promise<void> {
    if (this.saving || this.counselEditForm?.invalid || !this.select.trainingProgram || !this.validDate(this.counsel.counseledAt)) return;
    this.saving = true;
    try {
      const json = {
        ...this.counsel,
        memberId: this.memberId,
        studioId: this.member?.studioId,
        personalId: this.personal?.id,
      };
      json.trainingProgramId = this.select.trainingProgram?.id;
      if (this.counsel.weightInteger != null) {
        json.weight = parseFloat(String(this.counsel.weightInteger) + '.' + (this.counsel.weightDecimal ?? 0));
      } else { json.weight = null; }
      if (this.counsel.bodyFatPercentageInteger != null) {
        json.bodyFatPercentage = parseFloat(String(this.counsel.bodyFatPercentageInteger) + '.' + (this.counsel.bodyFatPercentageDecimal ?? 0));
      } else { json.bodyFatPercentage = null; }
      if (this.counsel.muscleMassInteger != null) {
        json.muscleMass = parseFloat(String(this.counsel.muscleMassInteger) + '.' + (this.counsel.muscleMassDecimal ?? 0));
      } else { json.muscleMass = null; }
      if (this.counsel.thighCircumferenceInteger != null) {
        json.thighCircumference = parseFloat(String(this.counsel.thighCircumferenceInteger) + '.' + (this.counsel.thighCircumferenceDecimal ?? 0));
      } else { json.thighCircumference = null; }
      if (this.counsel.hipCircumferenceInteger != null) {
        json.hipCircumference = parseFloat(String(this.counsel.hipCircumferenceInteger) + '.' + (this.counsel.hipCircumferenceDecimal ?? 0));
      } else { json.hipCircumference = null; }
      if (this.counsel.abdominalCircumferenceInteger != null) {
        json.abdominalCircumference = parseFloat(String(this.counsel.abdominalCircumferenceInteger) + '.' + (this.counsel.abdominalCircumferenceDecimal ?? 0));
      } else { json.abdominalCircumference = null; }
      if (this.counsel.armCircumferenceInteger != null) {
        json.armCircumference = parseFloat(String(this.counsel.armCircumferenceInteger) + '.' + (this.counsel.armCircumferenceDecimal ?? 0));
      } else { json.armCircumference = null; }
      this.removeViewFields(json);
      const saved = await this.counselService.upsert(json);
      if (saved?.id) {
        // 旧版 counsel.js:248-252: Flash・先頭へscroll 後に編集画面へ遷移（表示は counsel-edit の <flash-message>）
        this.flash.create('success', 'カウンセリングデータを新規作成しました');
        window.scrollTo(0, 0);
        this.router.navigate(['/counsel', saved.id, 'edit']);
      }
    } finally {
      this.saving = false;
    }
  }

  private removeViewFields(json: any): void {
    [
      'weightInteger', 'weightDecimal',
      'bodyFatPercentageInteger', 'bodyFatPercentageDecimal',
      'muscleMassInteger', 'muscleMassDecimal',
      'thighCircumferenceInteger', 'thighCircumferenceDecimal',
      'hipCircumferenceInteger', 'hipCircumferenceDecimal',
      'abdominalCircumferenceInteger', 'abdominalCircumferenceDecimal',
      'armCircumferenceInteger', 'armCircumferenceDecimal',
      'personal', 'createdAt', 'updatedAt',
    ].forEach(key => delete json[key]);
  }
  readonly validDate = validOptionalBusinessDate;
}
